import { render } from "./MultiSelectItem.vue?vue&type=template&id=d12cd180&scoped=true"
import script from "./MultiSelectItem.vue?vue&type=script&lang=js"
export * from "./MultiSelectItem.vue?vue&type=script&lang=js"

import "./MultiSelectItem.vue?vue&type=style&index=0&id=d12cd180&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d12cd180"]])

export default __exports__